module.exports = "<!-- tabla principal -->\n<div class=\"row\">\n  <div class=\"col-12 dy-table\">\n    <ng2-smart-table [settings]=\"settings\" [source]=\"sourceData\"></ng2-smart-table>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administration/creation-dynamic-component/creation-form/filter-procedure/filter-procedure.component.html
// module id = ./src/app/administration/creation-dynamic-component/creation-form/filter-procedure/filter-procedure.component.html
// module chunks = main